import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Import } from '../type/import.type';
import { environment } from 'src/environments/environment';
import { ImportResponse } from '../type/import_response.type';
import { v4 as uuidv4 } from 'uuid';
import { MailResponse } from '../type/mail_response.type';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}`;

  generateUuid(): string {
    return uuidv4();
  }

  getFiles(): Observable<Import[]> {
    return this.http.get<ImportResponse[]>(`${this.apiUrl}/imports`)
      .pipe(map(this.mapImportResponsesToImports));
  }

  uploadFiles({ files }: { files: Import[] }): Observable<Import[]> {
    const token = localStorage.getItem('access_token');
    const formData = this.createFormData(files);
    const headers = { Authorization: `Bearer ${token}` };
    return this.http.post<ImportResponse[]>(`${this.apiUrl}/imports`, formData, { headers })
      .pipe(map(this.mapImportResponsesToImports));
  }

  getMailtoAddress(): Observable<MailResponse[]> {
    return this.http.get<MailResponse[]>(`${this.apiUrl}/email/get`)
      .pipe(map(this.mapMailResponsesToMailAddresses));
  }

  extractFret21(emailType: string, selectedFiles: string): Observable<string> {
    const body: any = { emailType, selectedFiles };
    return this.http.post<string>(`${this.apiUrl}/email/send`, body);
  }

  private mapImportResponsesToImports(importResponses: ImportResponse[]): Import[] {
    return importResponses.map((importItem) => ({
      id: importItem.id,
      label: importItem.label,
      status: importItem.status,
      type: importItem.type_of_file,
      file: new File([], importItem.file_name),
      date: importItem.created_at,
      referential_client_id: String(importItem.referential_client_id),
      isReferential: importItem.isReferential
    }));
  }


  private mapMailResponsesToMailAddresses(mailResponses: MailResponse[]): MailResponse[]  {
    return mailResponses.map((response) => ({
      id: response.id,
      email: response.email,
      name: response.name
    }));
  }

  private createFormData(files: Import[]): FormData {
    const formData = new FormData();
    for (const file of files) {
      // On ne prend pas en compte la card vide
      if (file.label === undefined && file.file === undefined) continue;
      // On ne prend pas en compte les imports déjà envoyés
      if (file.status !== undefined) {
        continue;
      }

      formData.append('datas', JSON.stringify({ id: file.id, label: file.label }));
      formData.append('files', file.file);
    }
    return formData;
  }
}
